import colors from 'assets/theme-dark/base/colors';
import rgba from 'assets/theme/functions/rgba';

const { text, light } = colors;

const chip = {
  styleOverrides: {
    root: {
      color: text.main,
      backgroundColor: rgba(light.main, 0.2),
      '&:hover': {
        backgroundColor: rgba(light.main, 0.3)
      }
    }
  }
};

export default chip;
